import css from './VideoProcessingPlaceholder.module.scss';

export const VideoProcessingPlaceholder = () => {
  return (
    <div className={css.container}>
      <div className={css.content}>
        <span className={css.title}>Processing</span>
        <span className={css.description}>
          Working hard on processing the media so you can preview it as soon as possible.
        </span>
      </div>
    </div>
  );
};
